import { render } from "./agreeFormModal.vue?vue&type=template&id=8857ac4c&ts=true"
import script from "./agreeFormModal.vue?vue&type=script&lang=ts"
export * from "./agreeFormModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__